import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

export default {
    namespaced: true,

    state: {
        loading: false,
    },

    getters: {
        loading: (state) => !!state.loading,
    },

    mutations: {
        DESTROY_ALL_STARTED(state) {
            state.loading = true;
        },

        DESTROY_ALL_SUCCESS(state) {
            state.loading = false;
        },

        DESTROY_ALL_ERROR(state) {
            state.loading = false;
        },

        DESTROY_STARTED(state) {
            state.loading = true;
        },

        DESTROY_SUCCESS(state) {
            state.loading = false;
        },

        DESTROY_ERROR(state) {
            state.loading = false;
        },
    },

    actions: {
        async doDestroy({ commit, dispatch, rootGetters }, id) {
            try {
                commit('DESTROY_STARTED');
                const currentManage = rootGetters['auth/manage/currentManage'];
                const manageInput = new ManageModel(currentManage).getManageModel()
                await SubpropertyService.destroyAll([id], manageInput);

                commit('DESTROY_SUCCESS');

                Message.success(i18n('entities.subproperty.destroy.success'));


                dispatch(
                    `${'subproperty/list'}/doFetch`,
                    rootGetters[`${'subproperty/list'}/filter`], {
                        root: true,
                    },
                );
            } catch (error) {
                Errors.handle(error);
                commit('DESTROY_ERROR');
            }
        },

        async doDestroyAll({ commit, dispatch, rootGetters },
            ids,
        ) {
            try {
                commit('DESTROY_ALL_STARTED');
                const currentManage = rootGetters['auth/manage/currentManage'];
                const manageInput = new ManageModel(currentManage).getManageModel()
                await SubpropertyService.destroyAll(ids, manageInput);

                commit('DESTROY_ALL_SUCCESS');


                Message.success(
                    i18n('entities.subproperty.destroyAll.success'),
                );

                dispatch(
                    `${'subproperty/list'}/doFetch`,
                    rootGetters[`${'subproperty/list'}/filter`], {
                        root: true,
                    },
                );
            } catch (error) {
                Errors.handle(error);
                commit('DESTROY_ALL_ERROR');
            }
        },
    },
};